import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { ShippingFeesInterface } from 'common/types/entities/ShippingFeesInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createShippingFees = (
  parentId: string,
  masterBlockId?: MasterBlockId,
): ShippingFeesInterface => {
  return {
    ...generateBaseEntity(EntityTypeEnum.ShippingFees, parentId, masterBlockId),
    type: EntityTypeEnum.ShippingFees,
    parentId: parentId,
    fontSize: 16,
    padding: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
    },
  }
}
